import React from 'react';
import Reflux from 'reflux';
import { Modal, Button, Row, Col } from 'bootstrap';
import ConfirmActions from 'flux/actions/ConfirmActions';
import ConfirmStore from 'flux/stores/ConfirmStore';

/**
 * Generic confirm
 *
 */
export default React.createClass({
  mixins: [Reflux.connect(ConfirmStore, 'confirm')],

  displayName: 'Confirm',

  render() {
    const children = [this._getHeaderNode(), this._getBodyNode()];

    return (
      <Modal
        autoFocus={false}
        show={this.isVisible()}
        onHide={this._handleClose}
        className="row"
      >
        {children}
      </Modal>
    );
  },

  _getHeaderNode() {
    const state = this.state.confirm;
    const title =
      state && state.get('title') ? state.get('title') : 'Are you sure?';

    return (
      <Modal.Header key="confirm-header" closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
    );
  },

  _getBodyNode() {
    const state = this.state.confirm;
    if (!state) return null;
    const question = state.get('question');

    const buttonOverride = state.get('buttonOverride');

    return (
      <Modal.Body key="confirm-body">
        <p>{question}</p>
        <Row>
          <Col lgOffset={12} lg={5} mdOffset={12} md={5} smOffset={12} sm={5}>
            <Button className="btn-cancel" onClick={ConfirmActions.cancel}>
              Cancel
            </Button>
          </Col>
          <Col lg={7} md={7} sm={7}>
            <button
              className={buttonOverride.buttonClass || 'btn-confirm'}
              autoFocus
              onClick={ConfirmActions.confirm}
            >
              {buttonOverride.buttonText || 'Yes, Proceed'}
            </button>
          </Col>
        </Row>
      </Modal.Body>
    );
  },

  _handleClose() {
    ConfirmActions.cancel();
  },

  isVisible() {
    return this.state.confirm ? true : false;
  },
});
